module.exports = __webpack_public_path__ + "DODGE-logo.png";